<template>
  <div class="nav-top-box">
    <div class="navtop">
    <div class="top-left">
      <img src="../static/icon-home.png" alt="" class="icon-home" />
      <div>{{ title }}</div>
    </div>
    <div class="top-right">
      <div
        :class="['text', pageInd == i ? 'active' : '']"
        v-for="(v, i) of navData"
        :key="v.dictCode"
        @click="checkPageInd(v, i,$event)"
      >
        {{ v.dictLabel }}
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    navData: {
      type: Array,
      default:[],
    },
  },
  data() {
    return {
      pageInd: 0,
    };
  },
  created() {},
  methods: {
    checkPageInd(v, ind, $event) {
      this.pageInd = ind;
      this.$emit("checkPageInd",{$event,...v})
    },
  },
};
</script>
<style scoped lang="less">
.nav-top-box{
  border-bottom: 1px solid #ececec;
}
.navtop {
  padding: 0 6.5rem /* 104/16 */;
  min-width: 93.75rem /* 1500/16 */;
  width: 93.75rem /* 1500/16 */;
  margin: 0 auto;
  padding-top: 20px;
  padding-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .top-left {
    display: flex;
    align-items: center;
    .icon-home {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
  }
  .top-right {
    display: flex;
    align-items: center;
    .text {
      margin-left: 20px;
      text-align: center;
      cursor: pointer;
      &.active {
        color: #1e439b;
      }
    }
  }
}
</style>
